import { LogbookInitializer as GlobalInitializer } from '@teamworks/global';

export class LogbookInitializer {

  static initialize() {
    GlobalInitializer.initialize();
  }

}
